import { Text } from "@certn/cascadia";
interface PackageDescriptionProps {
  description: string;
  testID: string;
}

export function PackageDescription({
  description,
  testID,
}: PackageDescriptionProps) {
  return (
    <Text
      style="global/body-secondary"
      color="text-weak"
      testID={`${testID}-package-description`}
    >
      {description}
    </Text>
  );
}
